module.exports = __webpack_public_path__ + "img/ae08.9725922a.jpg";